import { Component, Input, OnInit } from '@angular/core';
import { BaseClass } from '../../base-class/base-class';
import { IbaseService } from '../../base-service/ibase-service';
import { WebserviceService } from '../../services/webservice.service';

@Component({
  selector: 'app-featured-events',
  templateUrl: './featured-events.component.html',
  styleUrls: ['./featured-events.component.css']
})
export class FeaturedEventsComponent extends BaseClass<any> implements OnInit {

  public data: any;

  constructor(public service: WebserviceService,
  ) { super(document); }

  ngOnInit(): void {
    this.getFeaturedEvents();
  }

  getFeaturedEvents() {
    let events = this.getLocalItem('sideMenu');
    if (events != null) {
      const groupedF = this.groupBy(events, (dat: any) => dat.shortcut_event);
      this.data = groupedF.get(1) ? groupedF.get(1) : [];
    }
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  ngDoCheck() {
    if (!this.data) {
      this.getFeaturedEvents();
    }
  }

}
